import { Box, Icon, Text, getThemeColor } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const IconContainer = styled(Box)<{ color: string }>`
  background-color: ${({ color, theme }) =>
    `${getThemeColor(color, theme) || color}22`};
  padding: 10px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
`

export const StyledIcon = styled(Icon)<{ color: string }>`
  color: ${({ color, theme }) => getThemeColor(color, theme) || color};
`

export const Value = styled.span`
  font-size: 40px;
  color: ${({ theme }) => getThemeColor('grey_1', theme)};
`

export const Title = styled(Text)`
  p {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`
